import {observer, React} from '@api'
import {useWhiteboardStore} from '@modules/whiteboard'
import { Tooltip } from '~components/Tooltip'
import { ToolButton } from '~components/ToolButton'
import { TrashIcon } from '~components/icons'

export const DeleteButton = observer(function DeleteButton() {
    const {hasSelection, deleteShapes} = useWhiteboardStore()

  const handleDelete = React.useCallback(() => {
    deleteShapes()
  }, [])

  return (
    <Tooltip label="Delete" kbd="⌫">
      <ToolButton variant="circle" disabled={!hasSelection} onSelect={handleDelete}>
        <TrashIcon />
      </ToolButton>
    </Tooltip>
  )
})


// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolsPanel/DeleteButton.tsx